import closeIcon from '@iconify/icons-ant-design/close-outline';
// import registrationThumbnail from '@/../img/chart-thumbnails/registration.svg';
import adrThumbnail from '@/../img/chart-thumbnails/adr.svg';
// -------------- maybe move to another file
import currentStrPropertiesThumbnail from '@/../img/chart-thumbnails/current-str-properties.svg';
import mostActiveHostsThumbnail from '@/../img/chart-thumbnails/most-active-hosts.svg';
import mostActiveOwnersThumbnail from '@/../img/chart-thumbnails/most-active-owners.svg';
import occupancyThumbnail from '@/../img/chart-thumbnails/occupancy.svg';
import onlinePlatformsThumbnail from '@/../img/chart-thumbnails/online-platforms.svg';
import rentalCategoriesThumbnail from '@/../img/chart-thumbnails/rental-categories.svg';
// import registrationThumbnail from '@/../img/chart-thumbnails/registration.svg';
import rentalSizeThumbnail from '@/../img/chart-thumbnails/rental-size.svg';
import rentalStructureThumbnail from '@/../img/chart-thumbnails/rental-structure.svg';
import rentalTypeThumbnail from '@/../img/chart-thumbnails/rental-type.svg';
import residentialTypeThumbnail from '@/../img/chart-thumbnails/residential-type.svg';
import revenueThumbnail from '@/../img/chart-thumbnails/revenue.svg';
import topOnlinePlatformsThumbnail from '@/../img/chart-thumbnails/top-online-platforms.svg';
import totThumbnail from '@/../img/chart-thumbnails/tot.svg';
import chunk from 'lodash/chunk';
import React, { Suspense } from 'react';
import { connect } from 'react-redux';
import { Badge, Button } from 'rsuite';
import { cssVars } from '@/app/styles';
import {
  dataTypeKeyNameMap,
  datasetTypeLabels,
  datasetTypes,
} from '@/constants';
import * as acm from '@/dashboard/components/add-chart-modal-styles';
import {
  CustomerConfigTranslatedStringKeyPaths,
  TranslationTypes,
} from '@/translations/constants';
import styled from 'styled-components';
import { translations } from '../../data/data-selectors';
import { t, translateString } from '../../translations/helpers';
import { AddChartItem } from './add-chart-item';
import { ChartsToPrint } from './charts-to-print';

// TODO: We should find a place for these types of values (maybe constants)
// this.thumbnail
const thumbnails = {
  [datasetTypes.CURRENT_STR_PROPERTIES]: {
    thumbnail: currentStrPropertiesThumbnail,
    description: 'Time series on active listings',
  },
  [datasetTypes.OCCUPANCY]: {
    thumbnail: occupancyThumbnail,
    description: 'Time series on monthly bookings',
  },
  [datasetTypes.AVG_DAILY_RATE]: {
    thumbnail: adrThumbnail,
    description: 'Time series on ADR',
  },
  [datasetTypes.REVENUE]: {
    thumbnail: revenueThumbnail,
    description: 'Time series on estimated revenue',
  },
  [datasetTypes.TRANSIENT_OCCUPANCY_TAX]: {
    thumbnail: totThumbnail,
    description: `Time series on monthly revenue-${t(
      CustomerConfigTranslatedStringKeyPaths.TOT,
      TranslationTypes.SHORT
    )} gap`,
  },
  [datasetTypes.UNIT_TYPE]: {
    thumbnail: rentalTypeThumbnail,
    description: 'Monthly distribution by STR unit type',
  },
  [datasetTypes.RESIDENTIAL_TYPE]: {
    thumbnail: residentialTypeThumbnail,
    description: 'Monthly categorization breakdown',
  },
  [datasetTypes.ONLINE_PLATFORMS]: {
    thumbnail: onlinePlatformsThumbnail,
    description: 'Monthly distribution of listings by platform',
  },
  [datasetTypes.RENTAL_SIZE]: {
    thumbnail: rentalSizeThumbnail,
    description: 'Monthly categorization breakdown',
  },
  [datasetTypes.RENTAL_STRUCTURE]: {
    thumbnail: rentalStructureThumbnail,
    description: 'Monthly categorization breakdown',
  },
  [datasetTypes.RENTAL_CATEGORIES]: {
    thumbnail: rentalCategoriesThumbnail,
    description: 'Breakdown categories by rental categories',
  },
  [datasetTypes.MOST_ACTIVE_HOSTS]: {
    thumbnail: mostActiveHostsThumbnail,
    description: 'Highest ranking list of hosts',
  },
  [datasetTypes.MOST_ACTIVE_OWNERS]: {
    thumbnail: mostActiveOwnersThumbnail,
    description: 'Highest ranking list of owners',
  },
  [datasetTypes.TOP_ONLINE_PLATFORMS]: {
    thumbnail: topOnlinePlatformsThumbnail,
    description: 'Current breakdown listings by online platforms',
  },
};

const RsModal = React.lazy(() => import('@/widgets/components/rs-modal'));

const StyledRsModal = styled(RsModal)`
  .rs-modal-content {
    padding-left: ${cssVars.rsModalPaddingLR};
    padding-right: ${cssVars.rsModalPaddingLR};
  }
`;

/**
 * Handles formatting the chartItem buttons into rows of two
 * @param {*} chartItems buttons to add charts
 */
function formatChartItems(chartItems) {
  const COLUMN_SIZE = 2;
  const chunkedChartItems = chunk(chartItems, COLUMN_SIZE);
  const chartItemsToRender = chunkedChartItems.map((chartEntities, i) => (
    <acm.StyledChartItemPair key={i}>
      {chartEntities.map((chartItem) => chartItem)}
    </acm.StyledChartItemPair>
  ));
  return chartItemsToRender;
}

const TRANSLATIONS_PROP_NAME = 'translations';

export class ChartSelectionModal extends React.Component {
  constructor(props) {
    super(props);
    this.printableContent = React.createRef();
    this.state = {
      selectedCards: [],
      selectedCount: 0,
    };
  }

  ModalTitle = () => <acm.StyledTitleText title="Add chart" />;

  // eslint-disable-next-line arrow-body-style
  AddChartHeader = () => {
    return (
      <acm.HeaderWrapper>
        <acm.TitleExitWrapper>
          {this.ModalTitle()}
          <acm.StyledIconButton
            onClick={() => this.handleClose()}
            icon={<acm.CloseIcon icon={closeIcon} />}
            appearance="subtle"
          />
        </acm.TitleExitWrapper>
        <acm.StyledSelectedLabel>{`${this.state.selectedCount} chart selected`}</acm.StyledSelectedLabel>
        <acm.StyledHeaderDivider />
      </acm.HeaderWrapper>
    );
  };

  StyledAddButton = () => (
    <Button onClick={() => this.handleAddSelected()}>Add</Button>
  );

  AddButton = () => {
    if (this.state.selectedCount > 0) {
      return (
        <Badge content={`${this.state.selectedCount}`}>
          {this.StyledAddButton()}
        </Badge>
      );
    }
    return this.StyledAddButton();
  };

  /**
   * Controls the current selected list
   * @param {*} card Item to be added or removed
   * @param {*} active Boolean - if item is selected
   */
  stageSelected(card, active) {
    // If the item is not already selected
    const { selectedCards } = this.state;
    if (!active) {
      // Spread it into new selected array
      const addSelected = [...selectedCards, card];
      // Update the selected array and increase selected count
      this.setState({
        selectedCount: selectedCards.length + 1,
        selectedCards: addSelected,
      });
    } else {
      // If the item is currently selected, we're removing it from selected
      const selected = [...selectedCards];
      // Find the index of the item being removed and cut it from list
      selected.splice(
        selected.findIndex((item) => item === card),
        1
      );
      // Update state
      this.setState({
        selectedCount: selected.length,
        selectedCards: selected,
      });
    }
  }

  handleClose = () => {
    this.setState({ selectedCards: [] });
    // reset count
    this.setState({ selectedCount: 0 });
    // close modal
    this.props.onHide();
  };

  /**
   * Called when ready to submit selected
   */
  handleAddSelected() {
    // Call parent function to show updated cards
    this.props.showHideCards(this.state.selectedCards);
    // reset selected
    this.handleClose();
  }

  handlePrintSelected() {
    this.props.printSelected(this.state.selectedCards);
    this.handleClose();
  }

  /**
   * Handler function for building and formatting chartItem Buttons
   */
  getFormattedChartItems() {
    const allTranslations = this.props[TRANSLATIONS_PROP_NAME] ?? {};

    const chartItems = Object.keys(dataTypeKeyNameMap).map((chartName, i) => {
      const description = translateString(
        thumbnails[chartName].description,
        allTranslations
      );

      const title = translateString(
        datasetTypeLabels[chartName],
        allTranslations
      );

      return (
        <AddChartItem
          key={i}
          opacity={this.props.activeCards.includes(chartName)}
          id={chartName}
          onClick={this.stageSelected.bind(this)}
          Thumbnail={thumbnails[chartName].thumbnail}
          title={title}
          description={description}
        />
      );
    });

    return formatChartItems(chartItems);
  }

  render() {
    return (
      <>
        {this.props.kpiData && (
          <ChartsToPrint
            kpiData={this.props.kpiData}
            ref={this.printableContent}
            entitiesToPrint={this.state.selectedCards}
          />
        )}
        <Suspense fallback={<div />}>
          <StyledRsModal
            open={this.props.showModal}
            onClose={() => this.handleClose()}
            size="md"
          >
            {this.AddChartHeader()}
            <acm.AddChartItemWrapper>
              {this.getFormattedChartItems()}
            </acm.AddChartItemWrapper>
            <acm.StyledHeaderDivider />
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-end',
                marginTop: 30,
              }}
            >
              <div style={{ marginRight: 10 }}>{this.AddButton()}</div>
              <div>
                <Button onClick={this.handleClose}>Cancel</Button>
              </div>
            </div>
          </StyledRsModal>
        </Suspense>
      </>
    );
  }
}

export function connectTranslations(Component) {
  return connect((state) => ({
    [TRANSLATIONS_PROP_NAME]: translations(state),
  }))(Component);
}
